import React, { useEffect } from "react";

const AddressTextField3 = ({
  name,
  type,
  placeholder,
  className,
  onChange,
  onBlur,
  validation,
  validationMsg,
  onkeypress,
  value,
  maxlength,
  style,
  readonly,
  id
}) => {

  useEffect(() => {
    const input = document.getElementById(id);
    if (input) {
      input.value = ""; 
    }
  }, [id]); 


  return (
    <>
      <input
        name={name}
        id={id}
        placeholder={placeholder}
        className={className}
        type={type}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onkeypress}
        ref={validation}
        defaultValue={value}
        maxLength={maxlength}
        style={style}
        readOnly={readonly}
        autoComplete="new-password"  
      />
      {validationMsg && (
        <>
          <span className="address1_error error_msg">{validationMsg}</span>
        </>
      )}
    </>
  );
};
export default AddressTextField3;
